module.exports = __webpack_public_path__ + "static/ariahidden-2f5d6e471599c0d8b400716484a11b68.png";